import { Component, OnInit } from '@angular/core';
import { DashboardResponsiveApiModel } from '../../../shared/models/dashboard.model';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'cv-dashboard-window',
  templateUrl: './dashboard-window.component.html',
  styleUrls: ['./dashboard-window.component.scss']
})
export class DashboardWindowComponent implements OnInit {
    dashboardKey: string = "";
    dashboard: DashboardResponsiveApiModel = null;
    dashboardReady = false;
    hasAccess = false;

    constructor(
        public dashboardService: DashboardService,
    ) {
        this.dashboardService.isDashboardWindow = true;
    }

    async ngOnInit() {
        this.dashboardKey = location.search.substring(4);
        try {
            const [dashboard] = await Promise.all([
                this.dashboardService.loadWindowedDashboard(this.dashboardKey),
                this.dashboardService.getUserWorkspace(),
            ]);
            this.dashboard = dashboard;
            this.hasAccess = true;
        }
        catch {
            this.hasAccess = false;
        }
        this.dashboardReady = true;
    }
}
